import './slider-currently-playing.scss';
